import styled from 'styled-components';
import { EPOverview, ArchiveIcon } from '@rsos/assets/icons';
import { Box, Button, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import {
  QUEUE_FIXED_WIDTH,
  QUEUE_FULL_WIDTH,
} from '@rsos/constants/queueWidths';

export const Container = styled(Box).attrs(({ theme }) => ({
  horizontal: true,
  align: 'center',
  justify: 'space-between',
  position: 'relative',
  width: QUEUE_FIXED_WIDTH,
  height: 78,
  backgroundColor: 'background',
  color: 'background',
  borderBottom: `1px solid ${theme.colors.lightLineDivider}`,
  borderRight: `1px solid ${theme.colors.lightLineDivider}`,
}))`
  flex: 0 0 auto;
  font-family: 'Roboto', sans-serif;
  user-select: none;
  @media (max-width: ${BP_LAPTOP}px) {
    width: ${QUEUE_FULL_WIDTH};
  }
`;

export const Wrapper = styled.div`
  flex: 1 1 auto;
  padding: 5px 10px;
`;

export const Subtitle = styled(Text).attrs({
  color: 'primaryBase',
  size: 'small',
  fontWeight: 'bold',
})`
  padding-left: 6px;
`;

export const ButtonWrapper = styled(Box).attrs({
  horizontal: true,
  flow: 4,
})``;

export const ViewJurisdictionButton = styled(Button).attrs({
  btnType: 'tertiary',
  size: 'med',
})`
  padding: 8px;
  height: auto;
  width: 124px;
`;

export const StyledHomeIcon = styled(EPOverview)`
  width: 10px;
  height: 11px;
  margin-right: 4px;
`;

export const ClearAllButton = styled(Button).attrs({
  btnType: 'tertiary',
  size: 'med',
})`
  padding: 8px 12.5px;
  height: auto;
  width: 124px;
`;

export const StyledArchiveIcon = styled(ArchiveIcon)`
  width: 10px;
  height: 11px;
  margin-right: 4px;
`;

export const TooltipChild = styled(Box).attrs(() => ({
  position: 'absolute',
  color: 'background',
  bg: 'primaryText',
  borderRadius: '5px',
  p: '10px',
  display: 'none',
  width: 'max-content',
}))`
  white-space: nowrap;
  bottom: 110%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
`;

export const Tooltip = styled(Box).attrs(() => ({
  position: 'relative',
}))`
  &:hover ${TooltipChild} {
    display: flex;
  }
`;
